import { render } from "./UrgentJobsSection.vue?vue&type=template&id=22dab48a&scoped=true"
import script from "./UrgentJobsSection.vue?vue&type=script&lang=js"
export * from "./UrgentJobsSection.vue?vue&type=script&lang=js"

import "./UrgentJobsSection.vue?vue&type=style&index=0&id=22dab48a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22dab48a"]])

export default __exports__